import { useEffect } from 'react';
import { platformAdminEntry } from '../../lib/platformAdminEntry';

export function CentralHandoff({ path }: { path: string }) {
  const destination = platformAdminEntry('true', path);
  useEffect(() => {
    if (!destination) return;
    // Scripted replace has no referrerPolicy option. Prevent even the old URL
    // from being sent as a referrer before handing off in this same tab.
    const policy = document.createElement('meta');
    policy.name = 'referrer';
    policy.content = 'no-referrer';
    document.head.append(policy);
    window.location.replace(destination);
    return () => policy.remove();
  }, [destination]);
  if (!destination) return <p role="alert">This is not a Cartiq platform page.</p>;
  return (
    <main className="mx-auto max-w-xl space-y-4 p-8 text-primary">
      <h1 className="text-2xl font-semibold">Opening Cartiq platform administration in Tuolen</h1>
      <p className="text-sm text-mid">Tuolen verifies your platform access. No Cartiq session is transferred.</p>
      <a href={destination} rel="noreferrer" referrerPolicy="no-referrer" className="text-accent underline">
        Continue to Tuolen
      </a>
    </main>
  );
}
